import { useActiveLocation } from '@/hooks/useActiveLocation';

/** Renders nothing for single-location accounts. */
export function LocationPicker() {
  const { locations, locationId, setLocation } = useActiveLocation();
  if (locations.length <= 1) return null;

  return (
    <select
      value={locationId}
      onChange={(event) => setLocation(event.target.value)}
      className="rounded border border-rule bg-white px-2 py-1.5 text-small"
      aria-label="Location"
    >
      {locations.map((location) => (
        <option key={location._id} value={location._id}>
          {location.name}
        </option>
      ))}
    </select>
  );
}
